import { useTabContext } from '../context.esm.js';

function useTabListStyles() {
  var _useTabContext = useTabContext(),
      align = _useTabContext.align;

  var styleProps = {
    display: 'flex',
    borderWidth: ['border-b'],
    borderColor: 'border-gray-200'
  };

  switch (align) {
    case 'center':
      styleProps.justifyContent = 'justify-center';
      break;

    case 'end':
      styleProps.justifyContent = 'justify-end';
      break;

    default:
    case 'start':
      styleProps.justifyContent = 'justify-start';
      break;
  }

  return styleProps;
}

export default useTabListStyles;
//# sourceMappingURL=styles.esm.js.map
